import React from 'react'
import PropTypes from 'prop-types'
import NoCloseMatchDrawer from './address-validation/no-close-match-drawer'
import PoBoxMilitaryDrawer from './address-validation/po-box-military-drawer'
import PartiallyValidDrawer from './address-validation/partially-valid-drawer'
import GeoMismatchDrawer from './address-validation/geo-mismatch-drawer'

const AddressValidationDrawer = ({
    isOpen,
    onClose,
    isZero,
    isSingle,
    isPoxBoxOrMilitary,
    selectedAddress,
    setSelectedAddress,
    suggestions,
    enteredAddress
}) => {
    // PO Box / Military — strict block (takes priority)
    if (isPoxBoxOrMilitary) {
        return (
            <PoBoxMilitaryDrawer
                isOpen={isOpen}
                onClose={onClose}
                enteredAddress={enteredAddress}
            />
        )
    }

    // No close match — address cannot be verified
    if (isZero) {
        return (
            <NoCloseMatchDrawer
                isOpen={isOpen}
                onClose={onClose}
                enteredAddress={enteredAddress}
            />
        )
    }

    // Partially valid — single suggestion
    if (isSingle) {
        return (
            <PartiallyValidDrawer
                isOpen={isOpen}
                onClose={onClose}
                enteredAddress={enteredAddress}
                suggestions={suggestions}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
            />
        )
    }

    // Geo-mismatch — multiple suggestions
    return (
        <GeoMismatchDrawer
            isOpen={isOpen}
            onClose={onClose}
            enteredAddress={enteredAddress}
            suggestions={suggestions}
            selectedAddress={selectedAddress}
            setSelectedAddress={setSelectedAddress}
        />
    )
}

AddressValidationDrawer.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    isZero: PropTypes.bool,
    isSingle: PropTypes.bool,
    isPoxBoxOrMilitary: PropTypes.bool,
    selectedAddress: PropTypes.string,
    setSelectedAddress: PropTypes.func.isRequired,
    suggestions: PropTypes.array,
    enteredAddress: PropTypes.shape({
        address1: PropTypes.string,
        city: PropTypes.string,
        stateCode: PropTypes.string,
        postalCode: PropTypes.string
    })
}

export default AddressValidationDrawer
